import css from './index.module.scss';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from '@components/common';
import CpdProductAutocomplete from '../cpd-product-autocomplete';
import QuotePricePackageWrapper from '../quote-price-package-wrapper';

interface IQuoteProductDetails {
  productName: string;
  /** @deprecated Product options now come from CPD inside CpdProductAutocomplete. */
  productOptions?: any[];
  /** @deprecated Product options now come from CPD inside CpdProductAutocomplete. */
  filterProductOptions?: (...args: any[]) => void;
  handleProductSelection: (event: any, param: any) => void;
  /** @deprecated No client-side filtering / free-text products any more. */
  filter?: (options: any, params: any) => any;
  dealQuantity: string;
  dealQuantityUnit: string;
  selectedWeightSystemChildOptions: any[];
  productPackaging: string;
  moq: string;
  moqUnit: string;
  productNameDisable?: boolean;
  fobPriceManualOverride?: string;
  cfrPriceManualOverride?: string;
  cifPriceManualOverride?: string;
  exWorksPriceManualOverride?: string;
  ddpPriceManualOverride?: string;
  finalQuoteSellingPriceManualOverride?: string;
  basePriceManualOverride?: string;
}

const QuoteProductDetails = (props: IQuoteProductDetails) => {
  const {
    productName,
    handleProductSelection,
    dealQuantity,
    dealQuantityUnit,
    selectedWeightSystemChildOptions,
    productPackaging,
    moq,
    moqUnit,
    productNameDisable = false
  } = props;

  const { setValue, control } = useFormContext();

  const dealQuantityUnitAndInputOnChange = () => {
    props?.exWorksPriceManualOverride &&
      setValue(props.exWorksPriceManualOverride, false, { shouldDirty: false });

    props?.fobPriceManualOverride &&
      setValue(props.fobPriceManualOverride, false, { shouldDirty: true });

    props?.cfrPriceManualOverride &&
      setValue(props.cfrPriceManualOverride, false, { shouldDirty: false });

    props?.cifPriceManualOverride &&
      setValue(props.cifPriceManualOverride, false, { shouldDirty: false });

    props?.ddpPriceManualOverride &&
      setValue(props.ddpPriceManualOverride, false, { shouldDirty: false });
  };

  return (
    <div className={css.contentWrapper}>
      <div className={css.rowWrapper}>
        <Controller
          name={productName}
          control={control}
          render={({ field, fieldState }) => {
            return (
              <CpdProductAutocomplete
                value={field.value}
                onChange={(product) => handleProductSelection(null, product)}
                required
                label="Product"
                disabled={productNameDisable}
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
                rootClassName={css.AutoCompletetypeField}
              />
            );
          }}
        />

        <QuotePricePackageWrapper
          label="Deal Quantity"
          unitPlaceholder="Unit"
          inputPlaceholder="Deal Quantity"
          input={dealQuantity}
          inputOnChange={() => {
            dealQuantityUnitAndInputOnChange();
          }}
          unit={dealQuantityUnit}
          control={control}
          unitOptions={selectedWeightSystemChildOptions}
          unitOnChange={() => {
            dealQuantityUnitAndInputOnChange();
          }}
          inputRequired={true}
        />
      </div>
      <div className={css.rowWrapper}>
        <Controller
          name={productPackaging}
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              required
              label="Product Packaging"
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
            />
          )}
        />
        <QuotePricePackageWrapper
          label="MOQ"
          unitPlaceholder="Unit"
          inputPlaceholder="MOQ"
          input={moq}
          unit={moqUnit}
          control={control}
          unitOptions={selectedWeightSystemChildOptions}
        />
      </div>
    </div>
  );
};

export default QuoteProductDetails;
